module.exports = __webpack_public_path__ + "static/media/download.56514651.svg";